import { render, staticRenderFns } from "./MaterialTable.vue?vue&type=template&id=4fdff85c&scoped=true"
import script from "./MaterialTable.vue?vue&type=script&lang=js"
export * from "./MaterialTable.vue?vue&type=script&lang=js"
import style0 from "./MaterialTable.vue?vue&type=style&index=0&id=4fdff85c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdff85c",
  null
  
)

export default component.exports